export default __webpack_public_path__ + "static/media/Logo 3.31d8977b.png";